import { WeeklyGrid } from '../components/WeeklyGrid'

/**
 * Week page — the main weekly view.
 * Thin page component: just mounts WeeklyGrid which handles all state.
 */
export function Week() {
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <WeeklyGrid />
    </div>
  )
}
